import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-table',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './table.component.html',
  styleUrl: './table.component.css',
})
export class TableComponent {
  @Input() data: any[] = [];
  @Input() columns: { key: string; label: string }[] = [];
  @Input() actions: {
    class: string;
    icon: string;
    tooltip: string;
    callback: (item: any) => void;
    disabled?: (item: any) => boolean; // Nueva propiedad para deshabilitar el botón
  }[] = [];
  @Input() searchPlaceholder: string = 'Buscar...';
  @Output() search = new EventEmitter<string>();

  searchText: string = '';
  currentPage: number = 1;
  pageSize: number = 10;

  get totalPages(): number {
    return Math.ceil(this.filteredData.length / this.pageSize);
  }

  get filteredData(): any[] {
    return this.data.filter((item) =>
      this.columns.some((col) => {
        const value = this.getNestedProperty(item, col.key);
        return value?.toString().toLowerCase().includes(this.searchText.toLowerCase());
      })
    );
  }

  get paginatedData(): any[] {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    return this.filteredData.slice(startIndex, startIndex + this.pageSize);
  }

  applyFilter(): void {
    this.search.emit(this.searchText);
    this.currentPage = 1;
  }

  changePage(page: number): void {
    this.currentPage = page;
  }

  getEstadoLabel(estado: number): string {
    return estado === 1 ? 'Activo' : 'Inactivo';
  }

  getEstadoClass(estado: number): string {
    return estado === 1 ? 'bg-green-500' : 'bg-red-500';
  }

  getNivelAlcanzadoInfo(nivelAlcanzado: string): { label: string; class: string } {
    switch (nivelAlcanzado) {
      case 'LOGRO DESTACADO':
        return { label: 'Logro Destacado', class: 'bg-blue-500' };
      case 'LOGRO':
        return { label: 'Logro', class: 'bg-green-500' };
      case 'EN PROCESO':
        return { label: 'En Proceso', class: 'bg-orange-500' };
      case 'INICIO':
        return { label: 'Inicio', class: 'bg-red-500' };
      default:
        return { label: 'Desconocido', class: 'bg-gray-500' };
    }
  }

  // Función para acceder a propiedades anidadas
  getNestedProperty(obj: any, path: string): any {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
  }

  // Método para obtener las clases dinámicas de las acciones
  getActionClasses(action: any, item: any): any {
    return {
      [action.class]: true,
      'opacity-50 cursor-not-allowed': action.disabled && action.disabled(item),
    };
  }
}
